// Remembers the filter a list page last ran, for as long as the browser session lasts.
//
// Drilling into a sub-page unmounts the list, so without this the filter is rebuilt from its
// defaults whenever the user steps back up — through a breadcrumb, the browser's back button
// or the menu — and whatever they had narrowed the list to is gone. A plain module variable
// is deliberate: it lives exactly as long as the single-page app does, so a reload always
// starts clean and the filter never turns into a surprise that outlives the session.
//
// The key is the search-params class's own `saveType`, which is already a mandatory unique
// and stable string (the class name is not usable — minification mangles it).

const rememberedSearchItems: Record<string, Record<string, unknown>> = {};

// Copied on the way in and again on the way out: a search item holds arrays (offices,
// statuses, platforms) and a panel that edits one in place would otherwise be editing what
// was remembered, so what came back would never be what was left behind.
function copyFields(searchItem: Record<string, unknown>): Record<string, unknown> {
  const copy: Record<string, unknown> = {};
  for (const field of Object.keys(searchItem)) {
    const value = searchItem[field];
    copy[field] = Array.isArray(value) ? [...value] : value;
  }
  return copy;
}

function remember(key: string, searchItem: unknown): void {
  if (!key || !searchItem) return;
  rememberedSearchItems[key] = copyFields(searchItem as Record<string, unknown>);
}

function recall(key: string): Record<string, unknown> | null {
  if (!key || !rememberedSearchItems[key]) return null;
  return copyFields(rememberedSearchItems[key]);
}

export default { remember, recall };
